/**
 * Service for handling SSO provider assignments to users
 */

/**
 * Assigns an SSO provider to a user
 * @param {number|string} userId - The ID of the user
 * @param {string} provider - The SSO provider name (or 'unassigned' to remove assignment)
 * @returns {Promise<Object>} The response data from the server
 * @throws {Error} If the request fails
 */
const assignSsoProvider = async (userId, provider) => {
  if (!userId) {
    throw new Error('User ID is required');
  }

  const url = `/users/${userId}/assign_sso_provider`;

  const requestBody = {
    sso_provider: provider,
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document
          .querySelector('meta[name="csrf-token"]')
          ?.getAttribute('content'),
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.error ||
          errorData.message ||
          `HTTP error! status: ${response.status}`,
      );
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export default assignSsoProvider;
